if (!customElements.get('quick-add-modal')) {
  customElements.define('quick-add-modal', class QuickAddModal extends ModalDialog {
    constructor() {
      super();
      this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
    }

    hide(preventFocus = false) {
      const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (cartNotification) cartNotification.setActiveElement(this.openedBy);
      this.modalContent.innerHTML = '';

      if (preventFocus) this.openedBy = null;
      super.hide();
    }

    show(opener) {
      opener.setAttribute('aria-disabled', true);
      opener.classList.add('loading');
      opener.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      fetch(opener.getAttribute('data-product-url'))
        .then((response) => response.text())
        .then((responseText) => {
          const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
          this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');
          this.preventDuplicatedIDs();
          this.removeDOMElements();
          this.setInnerHTML(this.modalContent, this.productElement.innerHTML);
          if (window.Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }

          if (window.ProductModel) window.ProductModel.loadShopifyXR();

          this.removeGalleryListSemantic();
          this.updateImageSizes();
          this.preventVariantURLSwitching();
          super.show(opener);

          // selected color varianst check js starts from here
          if(this.querySelector(".variation-color-wrapper")){
            let $current_variant = this.getAttribute("data-selected_vartitle");
            if ($current_variant) {
              this.querySelector(".variation-color-wrapper").querySelectorAll("input").forEach((input) => {
                if ($current_variant.includes(input.value)) {
                  input.checked = true;
                  input.dispatchEvent(new Event('change', { bubbles: true }));
                }
              });
            }
          }
          
        })
        .finally(() => {
          opener.removeAttribute('aria-disabled');
          opener.classList.remove('loading');
          opener.querySelector('.loading-overlay__spinner').classList.add('hidden');
          this.BISfun()
        });
    }

    setInnerHTML(element, html) {
      element.innerHTML = html;

      // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
      element.querySelectorAll('script').forEach(oldScriptTag => {
        const newScriptTag = document.createElement('script');
        Array.from(oldScriptTag.attributes).forEach(attribute => {
          newScriptTag.setAttribute(attribute.name, attribute.value)
        });
        newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
        oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
      });
    }

    preventVariantURLSwitching() {
      const variantPicker = this.modalContent.querySelector('variant-radios,variant-selects');
      if (!variantPicker) return;

      variantPicker.setAttribute('data-update-url', 'false');
    }

    removeDOMElements() {
      const pickupAvailability = this.productElement.querySelector('pickup-availability');
      if (pickupAvailability) pickupAvailability.remove();

      const productModal = this.productElement.querySelector('product-modal');
      if (productModal) productModal.remove();

      const modalDialog = this.productElement.querySelectorAll('modal-dialog:not(.size-chart-popup-model-main)');
      if (modalDialog) modalDialog.forEach(modal => modal.remove());

      // The TextMe restock app block only initialises on a real product page, and it reuses the
      // same element ids as the theme back in stock form. Drop it from the cloned markup so the
      // theme form (wired up in BISfun) is the only notification form inside the quick view.
      this.productElement.querySelectorAll('.stock-notifier-container').forEach((container) => {
        (container.closest('.shopify-app-block') || container).remove();
      });
    }

    preventDuplicatedIDs() {
      const sectionId = this.productElement.dataset.section;
      this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${ sectionId }`);
      this.productElement.querySelectorAll('variant-selects, variant-radios, product-info').forEach((element) => {
        element.dataset.originalSection = sectionId;
      });
    }

    removeGalleryListSemantic() {
      const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
      if (!galleryList) return;

      galleryList.setAttribute('role', 'presentation');
      galleryList.querySelectorAll('[id^="Slide-"]').forEach(li => li.setAttribute('role', 'presentation'));
    }

    updateImageSizes() {
      const product = this.modalContent.querySelector('.product');
      const desktopColumns = product.classList.contains('product--columns');
      if (!desktopColumns) return;

      const mediaImages = product.querySelectorAll('.product__media img');
      if (!mediaImages.length) return;

      let mediaImageSizes = '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';
      
      if (product.classList.contains('product--medium')) {
        mediaImageSizes = mediaImageSizes.replace('715px', '605px');
      } else if (product.classList.contains('product--small')) {
        mediaImageSizes = mediaImageSizes.replace('715px', '495px');
      }

      mediaImages.forEach(img => img.setAttribute('sizes', mediaImageSizes));
    }

    BISfun(){
      // The app block was stripped in removeDOMElements, so stamp out the theme form that
      // buy-buttons ships as an inert <template> and wire it up for the modal.
      const template = this.modalContent.querySelector(".matat-backin-stock-template");
      if (template) {
        template.parentNode.insertBefore(template.content.cloneNode(true), template);
        template.remove();
      }

      this.modalContent.querySelectorAll("variant-radios input[type='radio']").forEach((e) => {
        e.addEventListener("change", (event)=> {
            let seletced_option = event.target.classList.contains("disabled");
            if(seletced_option == true){
              this.modalContent.querySelector(".matat-backin-stock-alert")?.classList.add("active");
              this.modalContent.querySelector(".product-form__submit")?.classList.add("hidden");
            }else{
              this.modalContent.querySelector(".product-form__submit")?.classList.remove("hidden");
              this.modalContent.querySelector(".matat-backin-stock-alert")?.classList.remove("active");
            }
        })
      })

      const phoneInput = this.modalContent.querySelector("#stock-phone");
      const validationMsg = this.modalContent.querySelector("#phoneValidationMsg");
      const submitButton = this.modalContent.querySelector(".matat-stock-notify-submit");

      if(phoneInput && validationMsg){
        phoneInput.addEventListener("keyup", ()=> {
          if(phoneInput.value.trim() === "") validationMsg.textContent = "";
        })
      }

      if(submitButton && phoneInput && validationMsg){
        submitButton.addEventListener("click", ()=> {
          validationMsg.textContent = '';
          if (!this.validatePhoneNumber(phoneInput.value)) {
            validationMsg.style.color = "red";
            validationMsg.textContent = "מספר טלפון לא תקין.";
            return;
          }

          // Same payload and endpoint the product page uses, so quick view submissions
          // land in the TextMe restock list too. id/variant_id/variant_title are resolved
          // live rather than read off the button, see matatSelectedVariant.
          const selectedVariant = this.matatSelectedVariant();
          const data = {
              phone: phoneInput.value,
              dialCode: "972",
              id: selectedVariant ? String(selectedVariant.id) : submitButton.getAttribute("data-id"),
              product_id: submitButton.getAttribute("data-product_id"),
              action: submitButton.getAttribute("data-action"),
              title: submitButton.getAttribute("data-title"),
              price_varies: JSON.parse(submitButton.getAttribute("data-price_varies")),
              price: submitButton.getAttribute("data-price"),
              price_max: submitButton.getAttribute("data-price_max"),
              price_min: submitButton.getAttribute("data-price_min"),
              has_only_default_variant: JSON.parse(submitButton.getAttribute("data-has_only_default_variant")),
              src: submitButton.getAttribute("data-src"),
              url: submitButton.getAttribute("data-url"),
              user_id: submitButton.getAttribute("data-user_id"),
              email: submitButton.getAttribute("data-email"),
              full_name: submitButton.getAttribute("data-full_name"),
              variant_id: selectedVariant ? String(selectedVariant.id) : submitButton.getAttribute("data-variant-id"),
              variant_title: selectedVariant && selectedVariant.title
                  ? selectedVariant.title
                  : submitButton.getAttribute("data-variant-title")
          };

          fetch('https://thesolidman.com/apps/text-me/restock-notifications', {
              method: 'POST',
              headers: {
                  'Content-Type': 'application/json',
                  "x-shopify-shop-domain": Shopify.shop
              },
              body: JSON.stringify(data)
          })
          .then(response => {
              if (!response.ok) {
                  throw new Error('Network response was not ok');
              }
              validationMsg.style.color = "green";
              validationMsg.textContent = 'אנו נחזור אליך ברגע שהמוצר יחזור למלאי';
          })
          .catch(error => {
              validationMsg.style.color = "red";
              validationMsg.textContent = "אירעה שגיאה. אנא נסה שוב.";
              console.error('Error:', error);
          });
        })
      }

    }

    // The submit button's data-* attributes are stamped from Liquid when the section is
    // rendered, and only ever described the page-load variant: data-variant-title was never
    // refreshed at all, and the data-id/data-variant-id refresh hung off a "change" listener
    // on input[name="id"] that did not reliably fire, so every submission reported the wrong
    // variant. The theme does keep that input's value in sync on each variant change, and
    // variant-radios/variant-selects expose the resolved variant, so read the selection at
    // submit time instead of trying to mirror it onto the button.
    matatSelectedVariant() {
      const picker = this.modalContent.querySelector('variant-radios, variant-selects');
      if (picker && picker.currentVariant) return picker.currentVariant;

      const idInput = this.modalContent.querySelector('.product-variant-id')
        || this.modalContent.querySelector('[name="id"]');
      const variantId = idInput && idInput.value;
      if (!variantId) return null;

      // Look the id up in the picker's variant JSON so the title always matches the id.
      const variantJson = picker && picker.querySelector('[type="application/json"]');
      if (!variantJson) return { id: variantId };
      try {
        const variants = JSON.parse(variantJson.textContent);
        return variants.find((variant) => String(variant.id) === String(variantId)) || { id: variantId };
      } catch (error) {
        return { id: variantId };
      }
    }

   validatePhoneNumber(number) {
      const phoneNumber = (number || '').trim();

      // Same Israeli mobile/landline pattern the product page validates against.
      const pattern = /^(?:(?:(\+?972|\(\+?972\)|\+?\(972\))?(?:\s|\.|-)?(5[0-9]{1}))|(0[23489]{1})|(0[57]{1}[0-9]))(?:\s|\.|-)?(\d{7}|([1-9]\d{8}))$/;

      return pattern.test(phoneNumber);
    }
  });
}
